// src/pages/Reportes.tsx
import React from "react";
import { Paper, Typography } from "@mui/material";

const Reportes: React.FC = () => {
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Reportes y Estadísticas
      </Typography>
      <Paper style={{ padding: "20px" }}>
        <Typography variant="body1">
          Aquí se mostrarán los reportes de turnos, cancelaciones, reventas e
          ingresos estimados. (Datos mock)
        </Typography>
        {/* Aquí se podrían incorporar gráficos o componentes de reportes */}
      </Paper>
    </div>
  );
};

export default Reportes;
